import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import dayjs from 'dayjs';

const PAGE_MARGIN = 14;

const COMPANY_LINES = [
  'GRUPO DRACENA S.A. \u2013 80070434-6',
  'G586+H48, UNNAMED ROAD, MINGA GUAZ\u00da 101112',
  '0982-491819 / E-MAIL: DRACENAPY@HOTMAIL.COM',
];

const TABLE_STYLE = { fontSize: 9, cellPadding: 3 };
const HEAD_STYLE = { fillColor: [220, 220, 220], textColor: 0, fontStyle: 'bold', halign: 'center' };

const addInnerHeader = (doc, pageWidth) => {
  doc.setDrawColor(180, 180, 180);
  doc.setLineWidth(0.4);
  doc.line(PAGE_MARGIN, 10, pageWidth - PAGE_MARGIN, 10);
  doc.setDrawColor(0);
};

const addPageNumber = (doc, num, pageWidth, pageHeight) => {
  // Pie: barra de color + info empresa + número de página
  doc.setFillColor(206, 220, 0);
  doc.rect(PAGE_MARGIN, pageHeight - 22, pageWidth - PAGE_MARGIN * 2, 2, 'F');
  doc.setFontSize(7);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(80);
  COMPANY_LINES.forEach((line, i) => {
    doc.text(line, pageWidth / 2, pageHeight - 18 + i * 4, { align: 'center' });
  });
  doc.setFontSize(8);
  doc.text(String(num), pageWidth / 2, pageHeight - 4, { align: 'center' });
  doc.setTextColor(0);
};

const BLOCKS_PDF = [
  {
    codigo: 'VISUAL_BORDES',
    title: 'Verifica\u00e7\u00e3o do Aspecto Visual e Bordas:',
    head: ['IDENTIFICA\u00c7\u00c3O C.P.', 'ASPECTO VISUAL', 'BORDAS'],
    fields: ['identificacion', 'aspecto_visual', 'bordas'],
  },
  {
    codigo: 'ESPESURA',
    title: 'Verifica\u00e7\u00e3o de espessura:',
    head: ['IDENTIFICA\u00c7\u00c3O C.P.', 'ESPESSURA NOMINAL', 'ESPESSURA MEDIDA', 'RESULTADO'],
    fields: ['identificacion', 'espesor_nominal', 'espesor_medida', 'resultado'],
  },
  {
    codigo: 'TEST_BAKE',
    titleSuffix: true,
    title: 'Teste de resistencia a altas temperaturas (Bake):',
    head: ['IDENTIFICA\u00c7\u00c3O C.P.', 'BOLHAS', 'NUBOSIDAD', 'RESULTADO'],
    fields: ['identificacion', 'burbujas', 'nubosidad', 'resultado'],
  },
  {
    codigo: 'HUMEDAD_A',
    title: 'Teste de resist\u00eancia \u00e0 umidade por condensa\u00e7\u00e3o (A):',
    head: ['IDENTIFICA\u00c7\u00c3O C.P.', 'BOLHAS', 'IDENTIFICA\u00c7\u00c3O', 'RESULTADO'],
    fields: ['identificacion', 'burbujas', 'identificacion', 'resultado'],
  },
  {
    codigo: 'HUMEDAD_B',
    title: 'Teste de Resist\u00eancia \u00e0 Umidade sem Condensa\u00e7\u00e3o (B):',
    head: ['IDENTIFICA\u00c7\u00c3O C.P.', 'BOLHAS', 'NUBOSIDAD', 'RESULTADO'],
    fields: ['identificacion', 'burbujas', 'nubosidad', 'resultado'],
  },
  {
    codigo: 'PUMMEL',
    titleSuffix: true,
    title: 'Teste de Ades\u00e3o/Pummel:',
    head: ['IDENTIFICA\u00c7\u00c3O C.P.', 'PUMMEL', 'RESULTADO'],
    fields: ['identificacion', 'pummel', 'resultado'],
  },
  {
    codigo: 'IMPACTO_PENDULO',
    titleSuffix: true,
    title: 'Teste de Impacto P\u00eandulo \u2013 Classe 1 e 2;',
    head: ['IDENTIFICA\u00c7\u00c3O C.P.', 'RESIST\u00caNCIA A IMPACTO', 'RESULTADO'],
    fields: ['identificacion', 'resistencia_impacto', 'resultado'],
  },
  {
    codigo: 'BALL_DROP',
    titleSuffix: true,
    title: 'Teste de Impacto Ball Drop - Classe A e B;',
    head: ['IDENTIFICA\u00c7\u00c3O C.P.', 'RESIST\u00caNCIA A IMPACTO', 'RESULTADO'],
    fields: ['identificacion', 'resistencia', 'resultado'],
  },
  {
    codigo: 'ANALISIS_PRODUCCION',
    title: 'An\u00e1lise durante a produ\u00e7\u00e3o:',
    head: ['ENSAIO', 'IDENTIFICA\u00c7\u00c3O C.P.', 'MAIOR RESULTADO', 'M\u00c1XIMO PERMITIDO', 'RESULTADO'],
    fields: ['ensayo', 'identificacion', 'mayor_resultado', 'maximo_permitido', 'resultado'],
  },
];

/**
 * Genera y descarga el informe PDF unificado de ensayos de vidrios laminados.
 */
export const exportarInformeLaboratorio = ({
  cliente = '',
  idProduccion = '',
  contextoChapa = null,
  pruebasSeleccionadas = [],
  resultadosPorBloque = {},
  resumenFinal = [],
  ensayoId = null,
  nominalThickness = '',
}) => {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const PW = doc.internal.pageSize.getWidth();
  const PH = doc.internal.pageSize.getHeight();
  const today = dayjs().format('DD/MM/YYYY');

  const s = (val) => (val == null ? '-' : String(val).trim() || '-');

  const tipoVidro = s(
    contextoChapa?.cod ||
    contextoChapa?.produto ||
    contextoChapa?.producto ||
    contextoChapa?.descripcion_producto ||
    idProduccion
  );

  const espessuraTotal = nominalThickness ? `${nominalThickness} mm` : '-';

  // ── PÁGINA 1: Portada ───────────────────────────────────────────────────────
  // Barra de color superior (simulando el logo)
  doc.setFillColor(206, 220, 0);
  doc.rect(PAGE_MARGIN, 15, PW - PAGE_MARGIN * 2, 2, 'F');
  doc.setFillColor(80, 80, 80);
  doc.rect(PAGE_MARGIN, 17, PW - PAGE_MARGIN * 2, 1, 'F');

  // Nombre empresa grande
  doc.setFontSize(28);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(80, 80, 80);
  doc.text('GRUPO', PW / 2 - 18, 50, { align: 'right' });
  doc.setTextColor(206, 220, 0);
  doc.text('DRACENA', PW / 2, 50);
  doc.setTextColor(80, 80, 80);
  doc.setFontSize(18);
  doc.text('S.A', PW / 2 + 48, 50);

  doc.setTextColor(0);

  // Título del reporte
  doc.setFontSize(13);
  doc.setFont('helvetica', 'bold');
  const titleLines = doc.splitTextToSize(
    'RELAT\u00d3RIO UNIFICADO DE ENSAIOS DE VIDROS LAMINADOS',
    PW - 50
  );
  doc.text(titleLines, PW / 2, 95, { align: 'center' });

  // Info del reporte
  doc.setFontSize(11);
  const infoStartY = 115;
  const infoRows = [
    ['Cliente:', s(cliente)],
    ['N\u00famero do Relat\u00f3rio:', s(ensayoId)],
    ['Data:', today],
    ['ID Produ\u00e7\u00e3o:', s(idProduccion)],
  ];
  infoRows.forEach(([label, value], i) => {
    doc.setFont('helvetica', 'bold');
    doc.text(label, PW / 2, infoStartY + i * 9, { align: 'center' });
    doc.setFont('helvetica', 'normal');
    doc.text(value, PW / 2, infoStartY + i * 9 + 5, { align: 'center' });
  });

  // Âmbito
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.text('\u00c2mbito de trabalho:', PAGE_MARGIN, 175);
  doc.text('Teste de seguran\u00e7a em vidro laminado.', PAGE_MARGIN, 182);

  // Footer portada
  addPageNumber(doc, 1, PW, PH);

  // ── PÁGINA 2: Identificação + Resumo + Objetivo ────────────────────────────
  doc.addPage();
  addInnerHeader(doc, PW);

  let y = 15;

  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.text('IDENTIFICA\u00c7\u00c3O DAS AMOSTRAS:', PAGE_MARGIN, y);
  y += 7;

  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text(
    `As amostras foram entregues em nosso laborat\u00f3rio em ${today}.`,
    PAGE_MARGIN,
    y
  );
  y += 6;

  autoTable(doc, {
    startY: y,
    head: [['IDENTIFICA\u00c7\u00c3O DA AMOSTRA', '']],
    body: [
      ['TIPO DE VIDRO', tipoVidro],
      ['PLACAS DE VIDROS', tipoVidro],
      ['ESPESSURA INDIVIDUAL DAS PLACAS (mm)', espessuraTotal],
      ['ESPESSURA TOTAL (mm)', espessuraTotal],
    ],
    styles: TABLE_STYLE,
    headStyles: { ...HEAD_STYLE, halign: 'center' },
    columnStyles: { 0: { fontStyle: 'bold', cellWidth: 95 } },
    margin: { left: PAGE_MARGIN, right: PAGE_MARGIN },
    theme: 'grid',
  });

  y = (doc.lastAutoTable?.finalY ?? y + 40) + 8;

  doc.setDrawColor(180, 180, 180);
  doc.setLineWidth(0.3);
  doc.line(PAGE_MARGIN, y, PW - PAGE_MARGIN, y);
  y += 7;

  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0);
  doc.text('RESUMO EXECUTIVO', PW / 2, y, { align: 'center' });
  y += 8;

  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  const resumoLines = doc.splitTextToSize(
    `Este relat\u00f3rio apresenta os resultados consolidados dos testes realizados pelo GRUPO DRACENA no vidro laminado fornecido ao cliente ${s(cliente)}.`,
    PW - PAGE_MARGIN * 2
  );
  doc.text(resumoLines, PAGE_MARGIN, y);
  y += resumoLines.length * 5 + 8;

  doc.setLineWidth(0.3);
  doc.line(PAGE_MARGIN, y, PW - PAGE_MARGIN, y);
  y += 7;

  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.text('OBJETIVO DOS TESTES', PW / 2, y, { align: 'center' });
  y += 8;

  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  const objLines = doc.splitTextToSize(
    'Avaliar e assegurar a conformidade t\u00e9cnica dos vidros laminados produzidos pelo GRUPO DRACENA em rela\u00e7\u00e3o \u00e0s normas t\u00e9cnicas aplic\u00e1veis, garantindo a qualidade, o desempenho estrutural, a durabilidade e a seguran\u00e7a do produto, tanto em condi\u00e7\u00f5es normais de uso quanto em situa\u00e7\u00f5es adversas ou extremas, de acordo com as especifica\u00e7\u00f5es estabelecidas pelas normas ABNT NBR 14697, NBR 7199 e ISO 12543.',
    PW - PAGE_MARGIN * 2
  );
  doc.text(objLines, PAGE_MARGIN, y);

  addPageNumber(doc, 2, PW, PH);

  // ── PÁGINA 3: Metodologia ──────────────────────────────────────────────────
  doc.addPage();
  addInnerHeader(doc, PW);

  y = 15;

  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('METODOLOGIA APLICADA', PAGE_MARGIN, y);
  y += 6;

  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text('Ensaios Complementares de Qualidade e Durabilidade.', PAGE_MARGIN, y);
  y += 5;
  doc.text(
    'As amostras foram submetidas a ensaios conforme requisitos da norma ABNT NBR 14697:',
    PAGE_MARGIN,
    y
  );
  y += 5;

  if (pruebasSeleccionadas.length) {
    pruebasSeleccionadas.forEach((p) => {
      doc.text(`\u2022 ${s(p.nombre || p.nome)}`, PAGE_MARGIN + 3, y);
      y += 5;
    });
  } else {
    doc.text('\u2022 Sem ensaios registados', PAGE_MARGIN + 3, y);
    y += 5;
  }

  y += 3;
  doc.setFont('helvetica', 'bold');
  doc.text('Identifica\u00e7\u00e3o e Dimens\u00f5es das Amostras:', PAGE_MARGIN, y);
  y += 4;

  autoTable(doc, {
    startY: y,
    head: [['Tipos de Teste', 'Identifica\u00e7\u00e3o C. P', 'Quantidade', 'Dimens\u00f5es']],
    body: pruebasSeleccionadas.map((p) => [
      s(p.nombre || p.nome),
      p.identificador_inicio
        ? `${p.identificador_inicio}${p.identificador_fin ? ' a ' + p.identificador_fin : ''}`
        : '-',
      s(p.cantidad_muestras),
      s(p.dimensiones),
    ]),
    styles: TABLE_STYLE,
    headStyles: HEAD_STYLE,
    margin: { left: PAGE_MARGIN, right: PAGE_MARGIN },
    theme: 'grid',
  });

  addPageNumber(doc, 3, PW, PH);

  // ── PÁGINAS DE RESULTADOS ──────────────────────────────────────────────────
  doc.addPage();
  addInnerHeader(doc, PW);

  y = 15;
  let currentPage = 4;

  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('RESULTADOS OBTIDO', PAGE_MARGIN, y);
  y += 8;

  BLOCKS_PDF.forEach((blockDef) => {
    const rows = resultadosPorBloque[blockDef.codigo] || [];

    // Skip blocks with no meaningful data
    const hasData = rows.some((row) =>
      blockDef.fields.some((f) => f !== 'identificacion' && f !== 'ensayo' && row[f])
    );

    if (!rows.length && !hasData) {
      return;
    }

    // New page if too close to bottom
    if (y > PH - 65) {
      addPageNumber(doc, currentPage, PW, PH);
      currentPage++;
      doc.addPage();
      addInnerHeader(doc, PW);
      y = 15;
    }

    const blockTitle = blockDef.titleSuffix
      ? `${blockDef.title} ${idProduccion || ''}`
      : blockDef.title;

    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.text(blockTitle, PAGE_MARGIN, y);
    y += 4;

    autoTable(doc, {
      startY: y,
      head: [blockDef.head],
      body: rows.map((row) =>
        blockDef.fields.map((f) => {
          const val = row[f];
          return val == null || val === '' ? '-' : String(val);
        })
      ),
      styles: TABLE_STYLE,
      headStyles: HEAD_STYLE,
      margin: { left: PAGE_MARGIN, right: PAGE_MARGIN },
      theme: 'grid',
      didParseCell: (data) => {
        if (data.section === 'body') {
          const cellText = String(data.cell.raw || '').toLowerCase();
          if (
            cellText.includes('aprovado') ||
            cellText.includes('aprobado') ||
            cellText.includes('ok')
          ) {
            data.cell.styles.textColor = [56, 142, 60];
          } else if (
            cellText.includes('n\u00e3o aprovado') ||
            cellText.includes('no aprobado') ||
            cellText.includes('no ok') ||
            cellText.includes('reprob')
          ) {
            data.cell.styles.textColor = [211, 47, 47];
          }
        }
      },
    });

    y = (doc.lastAutoTable?.finalY ?? y + 30) + 8;
  });

  // ── RESULTADO FINAL ────────────────────────────────────────────────────────
  if (y > PH - 80) {
    addPageNumber(doc, currentPage, PW, PH);
    currentPage++;
    doc.addPage();
    addInnerHeader(doc, PW);
    y = 15;
  }

  doc.setDrawColor(180, 180, 180);
  doc.setLineWidth(0.4);
  doc.line(PAGE_MARGIN, y, PW - PAGE_MARGIN, y);
  y += 7;

  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.text('RESULTADO FINAL DOS ENSAIOS', PAGE_MARGIN, y);
  y += 7;

  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');

  const aprovados = resumenFinal.filter(
    (r) =>
      r.resultado?.toLowerCase().includes('aprobado') ||
      r.resultado?.toLowerCase().includes('aprovado')
  );
  const reprovados = resumenFinal.filter(
    (r) =>
      !r.resultado?.toLowerCase().includes('aprobado') &&
      !r.resultado?.toLowerCase().includes('aprovado') &&
      !r.resultado?.toLowerCase().includes('pendiente')
  );

  if (aprovados.length) {
    const approvedIntroLines = doc.splitTextToSize(
      'De acordo com os ensaios realizados, as seguintes amostras foram aprovadas:',
      PW - PAGE_MARGIN * 2
    );
    doc.text(approvedIntroLines, PAGE_MARGIN, y);
    y += approvedIntroLines.length * 5 + 3;
    aprovados.forEach((r) => {
      const label = `\u2022 ${s(r.ensayo)}: `;
      doc.text(label, PAGE_MARGIN + 3, y);
      doc.setTextColor(56, 142, 60);
      doc.setFont('helvetica', 'bold');
      doc.text(s(r.resultado), PAGE_MARGIN + 3 + doc.getTextWidth(label), y);
      doc.setTextColor(0);
      doc.setFont('helvetica', 'normal');
      y += 5;
    });
    y += 3;
  }

  if (reprovados.length) {
    doc.text('Ensaios com resultado n\u00e3o conforme:', PAGE_MARGIN, y);
    y += 6;
    reprovados.forEach((r) => {
      const label = `\u2022 ${s(r.ensayo)}: `;
      doc.text(label, PAGE_MARGIN + 3, y);
      doc.setTextColor(211, 47, 47);
      doc.setFont('helvetica', 'bold');
      doc.text(s(r.resultado), PAGE_MARGIN + 3 + doc.getTextWidth(label), y);
      doc.setTextColor(0);
      doc.setFont('helvetica', 'normal');
      y += 5;
    });
    y += 3;
  }

  y += 4;
  doc.setLineWidth(0.5);
  doc.line(PAGE_MARGIN, y, PW - PAGE_MARGIN, y);
  y += 7;

  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('GRUPO DRACENA', PAGE_MARGIN, y);
  y += 5;
  doc.setFontSize(9);
  doc.setFont('helvetica', 'italic');
  doc.setTextColor(80);
  doc.text('Qualidade e Seguran\u00e7a em Vidros Laminados', PAGE_MARGIN, y);
  doc.setTextColor(0);

  addPageNumber(doc, currentPage, PW, PH);

  const filename = `informe_lab_${ensayoId || 'borrador'}_${dayjs().format('YYYYMMDD')}.pdf`;
  doc.save(filename);
};
